export default (value: boolean) => {
    if (value) {
        return 'On';
    }
    return 'Off';

}